import { Injectable } from '@angular/core';
import { ProductCrossReferenceAdapter } from './product-cross-reference.adapter';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProductCrossReferenceService {
  constructor(protected productCrossReferenceAdapter: ProductCrossReferenceAdapter) {}

  getProductCrossReference(code: string, searchType: string): Observable<any> {
    return this.productCrossReferenceAdapter.getProductCrossReference(code, searchType);
  }
}
